@if (type === noTextSadPath) {
  <div class="sadpath">
    <div class="content">
      <img src="/images/sadpath-open-search.svg" />
      <p class="body-medium-semi-bold">
        {{ 'OPEN_SEARCH.TECHNICAL-DIFFICULTIES' | translate }}
      </p>
      <p class="body-medium">
        {{ 'OPEN_SEARCH.TEXT-INCONVENIENCE' | translate }}
        <br />
        {{ 'OPEN_SEARCH.TEXT-AGAIN-LATER' | translate }}
      </p>
    </div>
  </div>
}
@if (type === noLengthSadPath) {
  <div class="sadpath-no-information">
    <div class="response-header">
      <mat-icon fontIcon="auto_fix_high" class="icon-s response-icon"></mat-icon>
      <div class="response-no-information">
        <p class="body-medium-bold">
          {{ 'OPEN_SEARCH.TEXT-IM-SORRY' | translate }}
        </p>
        <p class="body-large">
          {{ 'OPEN_SEARCH.TEXT-HOWEVER' | translate }}
          <br />
          {{ 'OPEN_SEARCH.TEXT-INLCUIDE' | translate }}
        </p>
        <ul class="document-list body-medium">
          <li>{{ 'OPEN_SEARCH.LI-LOAN' | translate }}</li>
          <li>{{ 'OPEN_SEARCH.LI-PCR' | translate }}</li>
          <li>{{ 'OPEN_SEARCH.LI-SFD' | translate }}</li>
          <li>{{ 'OPEN_SEARCH.LI-CS' | translate }}</li>
          <li>{{ 'OPEN_SEARCH.LI-STRATEGY' | translate }}</li>
          <li>{{ 'OPEN_SEARCH.LI-CATALOG' | translate }}</li>
        </ul>
        <p class="body-medium">
          {{ 'OPEN_SEARCH.TEXT-PLEASE' | translate }}
        </p>
      </div>
    </div>
  </div>
}
